<template>
  <div class="rule" :class="{ 'white-mode': !darkMode }">
    <div v-if="!isApply && loaded" class="rule__scroll">
      <div class="rule__wrap">
        <p class="rule__whitehint">注销风险说明</p>
        <div class="rule__p">
          【特别说明】亲爱的用户，在您正式开始下一步极氪订阅账号注销流程前，我们先为您做出如下特别说明：
        </div>
        <div class="rule__p">
          注销极氪订阅账号后，您将无法再以此账号登录和使用【浙江极氪智行科技服务有限公司或其关联公司】（以下简称“我们”）的相关产品与服务，我们也将同时终止为该账号提供我们的高品质、多元化的产品与服务。<span>您需重点关注，极氪订阅账号一旦注销完成，将无法恢复，</span>请您在注销前<span>慎重考虑</span>。
        </div>
        <div class="rule__p">
          若您经过慎重考虑后仍执意决定注销极氪订阅账号的，请您务必先行阅读和充分理解本《注销风险说明》，在同意全部内容后，按照我们的注销操作指引点击进行下一步操作，您勾选本注销风险说明并点击下一步注销操作的行为即意味着您已经同意签署和遵守本说明全部内容。如您在注销后需要再次使用我们的服务的，欢迎您使用手机号码或我们允许的其他方式重新注册。同时，我们也非常希望能够了解您使用我们的产品/服务体验，您可以通过客服或发邮件至【zeekrsubscription@zeekr.com】的方式反馈给我们，以便我们进一步改进和完善我们的产品和服务。
        </div>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">一、</view>您需要首先知悉的是：账号注销将会对您产生如下影响：
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">1.</view>
          极氪订阅账号一旦注销，您将无法登录、使用该账号（也包括无法再使用该账号作为第三方账号登录其他产品），也就是说您将无法再以此账号登录/使用/继续使用我们旗下的相关产品与服务；
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">2.</view>
          极氪订阅账号一旦注销，您曾通过该账号登录、使用的产品与服务下的所有内容、信息、数据、记录将会被删除或匿名化处理，您也无法再检索、访问、获取、继续使用和找回，除法律法规另有规定或监管部门另有要求，我们将不支持信息/数据的找回工作。虽然按照相关的法律要求，您的用户注册信息以及历史变更记录将会被永久保留，但是我们不会对您进行数据进行热处理（包括短信营销等）。包括：该账号下的个人资料（例如：头像、昵称等）及绑定信息（例如：绑定手机号等）；该账号下的您的个人信息（同时您亦不再享有《极氪订阅服务协议》《极氪订阅隐私政策》中约定的您的用户权利，但法律法规另有规定的除外）；该账号曾发表的所有内容（例如：评论、互动、聊天记录等）；
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">3.</view>
          您申请账号注销的行为即表明您同意放弃该账号在我们旗下的产品与服务使用期间已产生的但未消耗完毕的权益及未来的预期利益。即极氪订阅账号一旦注销，我们将会对该账号下的全部权益做清除处理，包括：优惠或权益会员等级、权益、卡券、成长值、积分、邀请记录将视为自动放弃而清除；
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">4.</view
          >极氪订阅账号一旦注销，您与我们曾签署过的相关用户协议、其他权利义务性文件等相应终止（但我们与您之间已约定继续生效的或法律法规另有规定的除外）。
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">5.</view>
          极氪订阅app账户注销后将无法恢复。若您再次注册极氪订阅账户或通过极氪APP触发订阅相关的功能，您的身份将会被识别为老用户，新用户的专属权益将不再享有；
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">6.</view>其他因极氪订阅账号注销产生的后果。
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">二、</view>
          在您向我们申请注销极氪订阅账号之前或正在申请注销极氪订阅账号的过程中，为保障您的账号安全和财产权益，请您先行检查与确保您申请注销的极氪订阅账号已经同时满足以下几点，包括：
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">1.</view
          >该账号是通过我们的官方渠道注册、符合《极氪订阅服务协议》及相关平台说明规范的账号；且为您本人注册的账号；
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">2.</view
          >极氪订阅app的订单已经完成。订单说明中账号下所有订单均已完成、已取消、已退款，包括但不限于订阅订单、充电订单；且订单中并无纠纷。
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">3.</view>其他为了保障您的账号安全和财产权益需要满足的内容。
        </p>
        <div class="rule__p">
          <span>当您通过注销账号页面确认申请注销账号，代表您同意并接受风险事项。</span>
        </div>
        <div class="rule__p">
          本说明之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因注销账号产生之争议，极氪订阅与您将尽最大诚意进行友好协商，如双方不能协商一致的，则任何一方有权向有管辖权的人民法院提起诉讼。
        </div>
      </div>
    </div>
    <div v-if="!isApply && loaded" class="rule__bottom">
      <div class="rule__bottom_btn" @click="apply">我已阅读并申请注销</div>
    </div>
    <div v-if="isApply" class="rule__empty">
      <div class="rule__empty_icon">
        <img src="@/static/image/empty_page.png" />
      </div>
      <div class="rule__empty_title">已收到您的注销申请</div>
      <div class="rule__empty_subtitle">
        我们将在7天内处理您的申请并删除您的所有数据。<br />
        如需帮助请联系客服400-003-6036
      </div>
    </div>

    <Popup :style="{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }" v-model:show="popupShow2">
      <div class="writeoff-popup">
        <div class="popup-icon-box">
          <img class="popup-icon" src="@/static/image/icon_info.png" />
        </div>
        <div class="popup-title">注销账号</div>
        <div class="popup-subtitle">注销后数据不可恢复，您确认要注销账号吗</div>
        <div class="popup-btn">
          <div class="btn-confirm" @click="confirm">确定</div>
          <div class="btn-cancel" @click="popupShow2 = false">再想想</div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { Toast, Popup } from 'vant'
import { userWriteoff, getUserStatus } from '@/api/faq'
import Ditto from '@zeekr-f2e/zeekr-ditto'
const route = useRoute()
const darkMode = ref(true)
if (route.query && route.query.mode === 'white') {
  darkMode.value = false
}
const isApp = ref(/ZEEKR-APP-(\w+)/.test(navigator.userAgent))
const realPhone = ref('')
const phone = ref('')
const vipCode = ref('')
const headImg = ref('')
const popupShow2 = ref(false)
const isApply = ref(false)
const loaded = ref(false)
const token = ref('')
const apply = () => {
  popupShow2.value = true
}
const getUserInfo = () => {
  Ditto.registerParams('common_js.getUserInfo').then(res => {
    if (res) {
      console.log('getUserInfo', res)
      if (res.vipCode) {
        vipCode.value = res.vipCode
        realPhone.value = res.realPhone || ''
        phone.value = res.phone || ''
        headImg.value = res.headImg || ''
        token.value = res.token || ''
        getUserStatusInfo()
      }
    }
  })
}
if (isApp.value) {
  getUserInfo()
} else {
  loaded.value = true
}
const getUserStatusInfo = () => {
  getUserStatus(
    {
      vipCode: vipCode.value,
      source: 0
    },
    {
      zeekrtoken: token.value
    }
  ).then(res => {
    if (res.data.code === '0') {
      isApply.value = true
    } else {
      isApply.value = false
    }
    loaded.value = true
  })
}
const confirm = () => {
  userWriteoff(
    {
      vipCode: vipCode.value,
      source: 0
    },
    {
      zeekrtoken: token.value
    }
  ).then(res => {
    if (res.data.code === '0') {
      popupShow2.value = false
      isApply.value = true
    } else {
      Toast(res.data.msg)
    }
  })
}
</script>
<style lang="scss" scoped>
.rule {
  background: #0b0b0b;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.white-mode {
  background-color: #fafafa;
  color: #232323;

  .rule__scroll,
  .rule__bottom {
    color: #232323;
  }

  .rule__p.rule__p--white,
  .rule__whitehint {
    color: black;
  }
}

.rule__list {
  margin-top: 40px;
  border-top: 2px solid #474747;
}

.rule__scroll {
  width: 100%;
  box-sizing: border-box;
  height: 1%;
  flex-grow: 1;
  overflow: auto;
  font-size: 24px;
  color: #9da2a5;
}

.rule__wrap {
  padding: 30px;
  padding-bottom: 200px;
}

.rule__bottom {
  position: fixed;
  bottom: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 26px;
  padding-bottom: calc(env(safe-area-inset-bottom) + 26px);
  font-size: 24px;
  font-weight: 400;
  line-height: 34px;
  color: #9da2a5;
  text-align: center;
  width: 100%;
  background-color: #fff;
}

.rule__bottom a {
  display: inline;
  font-size: 24px;
  color: #00cab7;
}

.rule__bottom_btn {
  width: 663px;
  line-height: 85px;
  border: 2px solid #64696b;
}

.rule__img {
  width: 100%;
  margin: 20px 0;
  display: block;
}

.rule__p.rule__p--mgt20 {
  margin-top: 20px;
}

.rule__p.rule__p--white {
  color: #fff;
}

.rule__p span {
  text-decoration-line: underline;
}

.rule__p.rule__p--flex {
  display: flex;
}

.rule__index {
  margin-right: 5px;
  flex-shrink: 0;
}

.rule__whitehint {
  color: #fff;
  font-size: 40px;
  margin-bottom: 30px;
}

.writeoff-popup {
  background-color: #fff;
  padding: 50px 28px 38px;

  .popup-icon {
    width: 73px;
    margin: 0 auto;
  }

  .popup-icon-box {
    display: flex;
    justify-content: center;
  }

  .popup-title {
    margin-top: 36px;
    color: #232323;
    text-align: center;
    font-size: 30px;
    line-height: 45px;
  }

  .popup-subtitle {
    margin-top: 10px;
    color: #64696b;
    text-align: center;
    font-size: 23px;
    font-style: normal;
    line-height: 34px;
  }

  .popup-btn {
    margin-top: 50px;
    display: flex;
    justify-content: space-between;

    .btn-confirm {
      color: #232323;
      border: 1px solid #64696b;
      text-align: center;
      width: 220px;
      line-height: 76px;
      font-size: 30px;
    }

    .btn-cancel {
      margin-left: 28px;
      background-color: #232323;
      color: white;
      text-align: center;
      text-align: center;
      width: 220px;
      line-height: 76px;
      font-size: 30px;
    }
  }
}
.rule__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 400px;
  .rule__empty_icon {
    img {
      width: 300px;
      height: 300px;
    }
  }
  .rule__empty_title {
    color: #64696b;
    text-align: center;
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 45px; /* 150% */
  }
  .rule__empty_subtitle {
    margin-top: 28px;
    color: #8e9496;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px; /* 150% */
  }
}
</style>
